// extracted by mini-css-extract-plugin
export var hideEditor = "_lg-2";
export var infoIcon = "_lg-3";
export var label = "_lg-1";
export var labelContainer = "_lg-0";
export var readonlyText = "_lg-4";